import { toggleClass, findParent } from "@src/utils/dom";
import "./index.css";
import { toggleScrollFixed } from "@src/utils/globalScrollHelper";
import updateShortlistCount from "./shortlist";

const LIST = "container-header-language-list";
const LIST_ACTIVE = "container-header-language-list__active";
const BUTTON = "headerChangeLanguage";
const MENU = "container-header-menu";
const L10n = "container-header-l10n";
const NAV = "container-header-nav";
const NAV_BG = "container-header-nav-bg";
const NAV_ACTIVE = "container-header-nav__active";
const NAV_CLOSE = "container-header-nav-close";
const NAV_L10N = "container-header-nav-l10n";
const NAV_L10N_ACTIVE = NAV_ACTIVE;

export function setupHeader() {
  updateShortlistCount();

  document
    .querySelector(`#${BUTTON}`)
    ?.addEventListener("click", function (this: HTMLElement, e: Event) {
      e.stopPropagation();
      const list = document.querySelector(`.${LIST}`) as HTMLElement;
      toggleClass(list, LIST_ACTIVE);
    });

  // click outside list hide the list
  document.addEventListener("click", function (e) {
    const activeList = document.querySelector(`.${LIST_ACTIVE}`) as HTMLElement;
    if (activeList && !findParent(e.target as HTMLElement, LIST)) {
      activeList.classList.remove(LIST_ACTIVE);
    }
  });

  // show l10n
  document
    .querySelector(`.${L10n}`)
    ?.addEventListener("click", function (this: HTMLElement, e: Event) {
      e.stopPropagation();
      const navL10n = document.querySelector(`.${NAV_L10N}`) as HTMLElement;
      toggleClass(navL10n, NAV_L10N_ACTIVE);
      toggleScrollFixed(true);
    });

  // close & empty close l10n
  document
    .querySelector(`.${NAV_L10N}`)
    ?.addEventListener("click", function (this: HTMLElement, e: Event) {
      const sourceEle = e.target as HTMLElement;
      if (!this.classList.contains(NAV_L10N_ACTIVE)) return;
      if (
        sourceEle.classList.contains(NAV_CLOSE) ||
        !findParent(sourceEle, NAV_BG)
      ) {
        this.classList.remove(NAV_L10N_ACTIVE);
        toggleScrollFixed(false);
      }
    });

  // show menu
  document
    .querySelector(`.${MENU}`)
    ?.addEventListener("click", function (this: HTMLElement, e: Event) {
      e.stopPropagation();
      const nav = document.querySelector(`.${NAV}`) as HTMLElement;
      toggleClass(nav, NAV_ACTIVE);
      toggleScrollFixed(true);
    });

  // close & empty  close menu
  document
    .querySelector(`.${NAV}`)
    ?.addEventListener("click", function (this: HTMLElement, e: Event) {
      const sourceEle = e.target as HTMLElement;
      if (!this.classList.contains(NAV_ACTIVE)) return;
      if (
        sourceEle.classList.contains(NAV_CLOSE) ||
        !findParent(sourceEle, NAV_BG)
      ) {
        this.classList.remove(NAV_ACTIVE);
        toggleScrollFixed(false);
      }
    });
}
